export default "__VITE_ASSET__2MBl8rqS__"